"use strict";
exports.__esModule = true;
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var router_1 = require("@angular/router");
var core_2 = require("@ngx-translate/core");
var constants_1 = require("../shared/constants");
var splash_screen_service_1 = require("../shared/splash-screen/splash-screen.service");
var utils_1 = require("../shared/utils");
var validate_token_service_1 = require("../shared/validate-token.service");
var signin_custom_validators_service_1 = require("../shared/validations/signin-custom-validators.service");
var claim_account_service_1 = require("./claim-account.service");
var ClaimAccountComponent = /** @class */ (function () {
    /**
     * @constructor for ClaimAccountComponent
     * @param {FormBuilder} formBuilder
     * @param {ValidateTokenService} validateTokenService to validate the token
     */
    function ClaimAccountComponent(formBuilder, claimAccountService, validateTokenService, router, splashScreenService, translate) {
        this.formBuilder = formBuilder;
        this.claimAccountService = claimAccountService;
        this.validateTokenService = validateTokenService;
        this.router = router;
        this.splashScreenService = splashScreenService;
        this.translate = translate;
        this.name = ' ';
        this.username = ' ';
        this.translatedParamName = '';
        this.disableForm = false;
        this.dataLoaded = false;
        this.redirectToLogin = false;
        this.passwordHidden1 = true;
        this.passwordHidden2 = true;
        this.isCookieEnabled = utils_1.Utils.isCookieEnabled();
        this.resetErrors();
        this.claimAccountForm = formBuilder.group({
            newPassword: ['', [
                    forms_1.Validators.required,
                    forms_1.Validators.minLength(8),
                    forms_1.Validators.maxLength(20),
                    signin_custom_validators_service_1.CustomValidators.oneUppercase,
                    signin_custom_validators_service_1.CustomValidators.oneDigitOrSpecialChar,
                    forms_1.Validators.pattern(constants_1.Constants.PASSWORD_PATTERN),
                ]],
            confirmPassword: ['', [forms_1.Validators.required, forms_1.Validators.minLength(8), forms_1.Validators.maxLength(20)]],
        }, {
            validator: this.passwordMatcher,
        });
        this.newPassword = this.claimAccountForm.controls['newPassword'];
        this.confirmPassword = this.claimAccountForm.controls['confirmPassword'];
        this.formOnChange();
    }
    ClaimAccountComponent.prototype.passwordMatcher = function (abstractControl) {
        var newPassword = abstractControl.get('newPassword').value;
        var confirmPassword = abstractControl.get('confirmPassword').value;
        if (!newPassword || !confirmPassword) {
            return null;
        }
        return newPassword === confirmPassword ? null : { nomatch: true };
    };
    ClaimAccountComponent.prototype.formOnChange = function () {
        var _this = this;
        this.claimAccountForm.valueChanges.subscribe(function (val) {
            _this.resetErrors();
        });
    };
    ClaimAccountComponent.prototype.onSubmit = function (newPassword, confirmPassword) {
        var _this = this;
        if (this.claimAccountForm.invalid || this.disableForm) {
            this.claimAccountForm.controls['newPassword'].markAsTouched();
            this.claimAccountForm.controls['confirmPassword'].markAsTouched();
            return;
        }
        this.disableForm = true;
        this.claimAccountService.post({
            password: newPassword,
            passwordConfirmation: confirmPassword,
            token: this.validateTokenService.token,
        }).subscribe(function (response) {
            _this.resetErrors();
            var href = utils_1.Utils.removeUrlParams(['token']);
            window.history.pushState(null, '', href);
            _this.router.navigate([constants_1.Constants.ROOT_URI + constants_1.Constants.LOGIN_ROUTE], { queryParams: utils_1.Utils.convertQueryStringToObject() });
        }, function (err) {
            _this.errorCode = utils_1.Utils.getErrorCodes(err);
            _this.error = err;
            _this.redirectForInvalidTokenOrUser();
            _this.disableForm = false;
        });
    };
    ClaimAccountComponent.prototype.ngOnInit = function () {
        var _this = this;
        // load DTM scripts
        utils_1.Utils.loadDTMScripts();
        this.splashScreenService.loaderObserver$.subscribe(function (dataLoaded) {
            _this.dataLoaded = dataLoaded;
        });
        this.validateToken();
    };
    ClaimAccountComponent.prototype.validateToken = function () {
        var _this = this;
        // validate token for /claim-account page
        if (utils_1.Utils.getParam(constants_1.Constants.TOKEN_PARAM) === null) {
            this.errorCode = 'PB-TOKEN-ERR-404';
            this.redirectForInvalidTokenOrUser();
        }
        else {
            this.validateTokenService.validateToken().subscribe(function (response) {
                _this.name = response['displayName'] ?
                    response['displayName'] : (response['firstName'] + constants_1.Constants.SPACE_STR + response['lastName']);
                _this.username = response['username'] ?
                    response['username'] : response['email'];
                _this.translate.get('CLAIM_ACCOUNT_PAGE.WELCOME', { name: _this.name })
                    .subscribe(function (res) {
                    _this.name = res;
                });
                _this.resetErrors();
                _this.splashScreenService.dataLoadedHandler(true);
            }, function (err) {
                _this.errorCode = utils_1.Utils.getErrorCodes(err);
                _this.error = err;
                _this.redirectForInvalidTokenOrUser();
            });
        }
    };
    // add margin for qtweb
    ClaimAccountComponent.prototype.isUnusualBrowser = function () {
        return utils_1.Utils.setUnusualBrowserSettings();
    };
    ClaimAccountComponent.prototype.showIcon = function (control, type) {
        if (control.touched) {
            if (control.hasError(type)) {
                return 'ui-1_bold-remove pbi-close text-danger';
            }
            if (control.hasError('required')) {
                return 'ui-2_small-delete-small';
            }
            return 'ui-1_check-simple pbi-check text-success';
        }
        return 'ui-2_small-delete-small';
    };
    /**
     * @function redirectForInvalidToken function to redirect
     * to reclaim account when token is invalid or expired or when user
     * tries to re-use the token to claim the account or when user is in
     * staged status.
     * PB-APIM-ERR-0019 - When the token is invalid
     * PB-APIM-ERR-0021 - When the token expired
     * PB-APIM-ERR-1000 - When token is missing in the URL
     * PB-LOGIN-ERR-004 - When user is not in ACTIVE status in OKTA
     * PB-TOKEN-ERR-404 - Token missing in the URL
     * @return void
     */
    ClaimAccountComponent.prototype.redirectForInvalidTokenOrUser = function () {
        if (this.errorCode === 'PB-APIM-ERR-0019' ||
            this.errorCode === 'PB-APIM-ERR-0021' ||
            this.errorCode === 'PB-APIM-ERR-1000' ||
            this.errorCode === 'PB-LOGIN-ERR-004' ||
            this.errorCode === 'PB-TOKEN-ERR-404') {
            var href = utils_1.Utils.removeUrlParams(['token', 'error']);
            window.history.pushState(null, '', href + '&error=' + this.errorCode);
            this.router.navigate([constants_1.Constants.ROOT_URI + constants_1.Constants.RECLAIM_ACCOUNT_ROUTE], { queryParams: utils_1.Utils.convertQueryStringToObject() });
        }
        else {
            var href = utils_1.Utils.removeUrlParams(['token']);
            window.history.pushState(null, '', href);
            this.router.navigate([constants_1.Constants.ROOT_URI + constants_1.Constants.LOGIN_ROUTE], { queryParams: utils_1.Utils.convertQueryStringToObject() });
        }
    };
    ClaimAccountComponent.prototype.resetErrors = function () {
        this.errorCode = '-1';
        this.error = '';
    };
    ClaimAccountComponent.prototype.setErrors = function (err) {
        var error = utils_1.Utils.getErrors(err);
        this.errorCode = error['errorCode'];
        this.error = err['message'];
    };
    ClaimAccountComponent.prototype.togglePasswordField = function (field, ele) {
        this[field] = !this[field];
        var pwd = document.getElementById(ele);
        pwd['type'] = this[field] ? 'password' : 'text';
    };
    return ClaimAccountComponent;
}());
exports.ClaimAccountComponent = ClaimAccountComponent;
